import * as ngCommon from '@angular/common'
import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../state'

@ngCore.Component({
  host: {
    // TODO: Once this component is reused, this can be removed.
    'data-atn-space-variant': 'full',
  },
  imports: [
    ds.layout.widget.Component,
    ds.tag.Component,
    ngCommon.DatePipe,
    ds.illustration.emptyState.Component,
  ],
  selector: 'atn-record-history-log',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** Requests the host to close the record history widget. */
  public readonly close = ngCore.output<void>()

  // TODO: Possibly make an input for records collection that will allow reuse
  // between full and lite space
  /** @see {@link state.space.full.records.Collection} */
  private readonly _recordsEc = ngCore.inject(
    state.space.full.records.Collection,
  )

  /** @see {@link state.space.userAccess.users.Collection} */
  public readonly usersEc = ngCore.inject(
    state.space.userAccess.users.Collection,
  )

  /** Record history log */
  public readonly recordHistorySg = ngCore.computed(
    (
      record = this._recordsEc.plugins.currentEntityPlugin.feature.selectors
        .getEntity()
        .asSignal(),
    ) => record?.history ?? [],
  )
}
